<div mat-dialog-title class="dialog-header">
    <span
        class="x-circle"
        hamIconShapes
        icon="assets/hamIcons/x-circle.svg"
        [variant]="'transparent'"
        [size]="'lg'"
        (click)="closeDialog()"
    ></span>
</div>
<div class="container dialog-content">
    <ng-container *ngIf="options">
        <aumico-form
            [options]="options"
            (isFormValid)="handleFormValidity($event)"
            [data]="data.subTotalSaveData"
            [delegate]="formDelegate"
            [disableSubmitButton]="disableSubmitButton"
        ></aumico-form>
    </ng-container>
</div>
